import { render, staticRenderFns } from "./ReceiptView.vue?vue&type=template&id=4a7afb6e&scoped=true"
import script from "./ReceiptView.vue?vue&type=script&lang=js"
export * from "./ReceiptView.vue?vue&type=script&lang=js"
import style0 from "./ReceiptView.vue?vue&type=style&index=0&id=4a7afb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7afb6e",
  null
  
)

export default component.exports